import axios from '../utils/axios';

export default function fetchAdditionalInfo(adminId, jobId, applicationId, params) {
    return (
        axios.get('/admin/' + adminId + '/job/' + jobId + '/applications/' + applicationId + '/additionalInfo', { params })
    )
}
